<div class="pageHeader">
  <span class="text-dark fw-bolder   fs-4 flex place-items-center justify-center justify-items-center items-center">
    <!-- <img src="assets/img/school.svg" class="svg-icon svg-icon-3" style="width:30px"/>  -->
    <span class="my-auto text-right">{{"common.booking_management" | translate}}</span>

  </span>

</div>
<div class="row clearfix text-start space-between">
  <div class="col-md-6 col-sm-12 ">
    <div class="row clearfix text-start">
      <div class="col-md-4 col-sm-12 mb-2">


        <nz-select class="booking-select" nzPlaceHolder="حالة االحجز" style="width: 100%"
          [(ngModel)]="appointmentStatus" (ngModelChange)="changeAppointmentStatus($event)">
          <nz-option nzLabel="{{'common.all' | translate}}" nzValue="0"></nz-option>
          <nz-option nzLabel="{{'common.active' | translate}}" nzValue="1"></nz-option>
          <nz-option nzLabel="{{'common.under_review' | translate}}" nzValue="2"></nz-option>
        </nz-select>
        <!-- <button (click)=" deleteall()"> deleteall</button> -->
      </div>
      <div class="col-md-4 col-sm-12 mb-2">


        <nz-select class="booking-select" nzPlaceHolder="{{'common.payment_status' | translate}}" style="width: 100%" [(ngModel)]="paymentStatus"
          (ngModelChange)="changePaymentStatus($event)">
          <nz-option nzLabel="{{'common.all' | translate}}" nzValue="0"></nz-option>
          <nz-option nzLabel="{{'common.paid' | translate}}" nzValue="1"></nz-option>
          <nz-option nzLabel="{{'common.unpaid' | translate}}" nzValue="2"></nz-option>
        </nz-select>
        <!-- <button (click)=" deleteall()"> deleteall</button> -->
      </div>
    </div>
  </div>
  <div class="col-md-3 col-sm-12 mb-2">

  </div>
  <div class="col-md-3 col-sm-12 mb-2">

    <nz-range-picker class="booking-date" [nzPlaceHolder]="['التاريخ من', 'إلى']" [nzRanges]="ranges"
      style="width: 100%" [(ngModel)]="todayDate" (ngModelChange)="onChangeDate($event)">
    </nz-range-picker>
    <!-- <button (click)=" deleteall()"> deleteall</button> -->
  </div>

</div>
<div class="card-body py-3 ">
  <!-- begin::Table container -->
  <div class="table-responsive">
    <!-- begin::Table -->
    <!-- <div style="display: none;">
      {{appointmentsList[0]['name']}}
    </div> -->
    <!-- <nz-spin [nzSpinning]="isAppointmentsLisLoading" > -->
    <nz-spin [nzSpinning]="isAppointmentsLisLoading">
      <table class="table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4"
        class="w-full divide-y divide-gray-300 p-2 overflow-x-auto md:rounded-lg bg-white">
        <!-- begin::Table head -->
        <thead>
          <tr class="fw-bolder text-muted">

            <th scope="col"
              class="py-3.5 pl-4 pr-3 text-left text-sm font-normal text-gray-600 sm:pl-6 capitalize text-right">

            </th>
            <th scope="col"
              class="py-3.5 pl-4 pr-3 text-left text-sm font-normal text-gray-600 sm:pl-6 capitalize text-right">
              {{'common.court' | translate}}
            </th>
            <th scope="col"
              class="py-3.5 pl-4 pr-3 text-left text-sm font-normal text-gray-600 sm:pl-6 capitalize text-right">
              {{'common.date_day' | translate}}
            </th>
            <th scope="col"
              class="py-3.5 pl-4 pr-3 text-left text-sm font-normal text-gray-600 sm:pl-6 capitalize text-right">
              {{'common.date' | translate}}
            </th>
            <th scope="col"
              class="py-3.5 pl-4 pr-3 text-left text-sm font-normal text-gray-600 sm:pl-6 capitalize text-right">
              {{'common.payment_method' | translate}}
            </th>
            <th scope="col"
              class="py-3.5 pl-4 pr-3 text-left text-sm font-normal text-gray-600 sm:pl-6 capitalize text-right">
              {{'common.amount' | translate}}
            </th>
            <th scope="col"
              class="py-3.5 pl-4 pr-3 text-left text-sm font-normal text-gray-600 sm:pl-6 capitalize text-right">
              {{'common.payment_status' | translate}}

            </th>
            <th scope="col"
              class="py-3.5 pl-4 pr-3 text-left text-sm font-normal text-gray-600 sm:pl-6 capitalize text-right">
              {{'common.booking_status' | translate}}

            </th>

            <th scope="col"
              class="py-3.5 pl-4 pr-3 text-left text-sm font-normal text-gray-600 sm:pl-6 capitalize text-right">
              {{'common.action' | translate}}
            </th>
          </tr>
        </thead>
        <!-- end::Table head -->
        <!-- begin::Table body -->

        <tbody>
          <ng-container *ngFor="let item of appointmentsList">


            <tr>

              <td class="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-light text-gray-900 sm:pl-6 text-right">
                <span class="d-flex align-items-center">

                  <div class="d-flex justify-content-start flex-column">
                    <a class="text-dark fw-bolder   fs-6">
                      {{item['customer']['name']}}

                    </a>
                    <span class="text-muted fw-bold text-muted d-block fs-7">
                      {{item['customer']['phone']}}

                    </span>
                  </div>
                </span>
              </td>
              <td class="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-light text-gray-900 sm:pl-6 text-right">
                <a class="text-dark fw-bolder   d-block fs-6">

                  {{item['court_name']}}
                </a>

              </td>
              <td class="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-light text-gray-900 sm:pl-6 text-right">

                <span class="">
                  <!--begin::Date-->
                  <span class="fs-6 text-gray-700 fw-bold">

                    {{item['date']}}
                  </span>
                  <!--end::Date-->

                  <!--begin::Label-->
                  <div *ngIf="item['working_day'] == '0'" class="fw-semibold text-gray-400">{{'common.sunday' | translate}}</div>
                  <div *ngIf="item['working_day'] == '1'" class="fw-semibold text-gray-400">{{'common.monday' | translate}}</div>
                  <div *ngIf="item['working_day'] == '2'" class="fw-semibold text-gray-400">{{'common.tuesday' | translate}}</div>
                  <div *ngIf="item['working_day'] == '3'" class="fw-semibold text-gray-400">{{'common.wednesday' | translate}}</div>
                  <div *ngIf="item['working_day'] == '4'" class="fw-semibold text-gray-400">{{'common.thursday' | translate}}</div>
                  <div *ngIf="item['working_day'] == '5'" class="fw-semibold text-gray-400">{{'common.friday' | translate}}</div>
                  <div *ngIf="item['working_day'] == '6'" class="fw-semibold text-gray-400">{{'common.saturday' | translate}}</div>


                  <!--end::Label-->
                </span>

              </td>

              <td class="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-light text-gray-900 sm:pl-6 text-right">

                <div class="text-blue-500 py-2 px-4 m-2">
                  <span class=" btn btn-outline btn-outline-dashed btn-outline-default w-100 p-4 flex" 
                  style="display: flex;gap: 5px;place-items: center;justify-content: center;direction: ltr;">

                 

                    <span class="fw-bolder fs-3" style="font-size: 14px !important;">  {{   tConvert(item['time']) }}  </span> <br>
                    <span class="fw-bolder fs-3" style="font-size: 14px !important;"> - </span>
                    <span class="fw-bolder fs-3" style="font-size: 14px !important;">  {{  addHours(item['time'])}}  </span>

                  </span>
                </div>
              </td>
              <td class="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-light text-gray-900 sm:pl-6 text-right">

                <div class="text-blue-500 py-2 px-4 m-2">
                  <span class="text-dark fw-bolder   d-block fs-6 text-blue-500">


                    <div *ngIf="item['payment_channel'] == '1'"
                      class="text-dark fw-bolder   d-block fs-8 text-blue-500">{{'common.at_arrival' | translate}} </div>
                    <div *ngIf="item['payment_channel'] == '2'"
                      class="text-dark fw-bolder   d-block fs-8 text-blue-500">{{'common.thawani' | translate}}  </div>
                  </span>
                </div>
              </td>
              <td class="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-light text-gray-900 sm:pl-6 text-right">

                <div class="text-blue-500 py-2 px-4 m-2">
                  <span class="text-dark fw-bolder   d-block fs-6 text-blue-500">

                    {{item['amount']}}

                  </span>
                </div>
              </td>
              <td class="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-light text-gray-900 sm:pl-6 text-right">


                <span class="flex">
                  <span *ngIf="item['payment_status'] === '1'"
                    class="inline-flex items-center px-4 py-2 rounded-full text-xs font-medium bg-green-100 text-green-800">
                    <span>{{"common.paid" | translate}}</span>
                  </span>


                  <span *ngIf="item['payment_status'] === '2'"
                    class="inline-flex items-center px-4 py-2 rounded-full text-sm font-medium bg-gray-100 text-gray-800">
                    <span>

                      {{"common.unpaid" | translate}}

                    </span>
                  </span>
                  <a *ngIf="item['payment_status'] === '2'" (click)="showPaymentStatusModal(item)" class="cursor-pointer">
                    <svg class="svg-icon svg-icon-3 cursor-pointer" width="24" height="24" viewBox="0 0 24 24"
                      fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path opacity="0.3"
                        d="M21.4 8.35303L19.241 10.511L13.485 4.755L15.643 2.59595C16.0248 2.21423 16.5426 1.99988 17.0825 1.99988C17.6224 1.99988 18.1402 2.21423 18.522 2.59595L21.4 5.474C21.7817 5.85581 21.9962 6.37355 21.9962 6.91345C21.9962 7.45335 21.7817 7.97122 21.4 8.35303ZM3.68699 21.932L9.88699 19.865L4.13099 14.109L2.06399 20.309C1.98815 20.5354 1.97703 20.7787 2.03189 21.0111C2.08674 21.2436 2.2054 21.4561 2.37449 21.6248C2.54359 21.7934 2.75641 21.9115 2.989 21.9658C3.22158 22.0201 3.4647 22.0084 3.69099 21.932H3.68699Z"
                        fill="#9da2a9" />
                      <path
                        d="M5.574 21.3L3.692 21.928C3.46591 22.0032 3.22334 22.0141 2.99144 21.9594C2.75954 21.9046 2.54744 21.7864 2.3789 21.6179C2.21036 21.4495 2.09202 21.2375 2.03711 21.0056C1.9822 20.7737 1.99289 20.5312 2.06799 20.3051L2.696 18.422L5.574 21.3ZM4.13499 14.105L9.891 19.861L19.245 10.507L13.489 4.75098L4.13499 14.105Z"
                        fill="#9da2a9" />
                    </svg>
                  </a>
                </span>




              </td>
              <td class="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-light text-gray-900 sm:pl-6 text-right">
                <span class="flex">
                  <!-- <nz-select  style="width: 100%" [(ngModel)]="{{item['status']}}"
            (ngModelChange)="updateAppointmentStatus(item['status'] ,item['id'])">
            <nz-option nzLabel="مفعّل" nzValue="1"></nz-option>
            <nz-option nzLabel="قيد المراجعة" nzValue="2"></nz-option>
          </nz-select> -->
                  <span *ngIf="item['status'] === '2'"
                    class="inline-flex items-center px-4 py-2 rounded-full text-xs font-medium bg-green-100 text-green-800">
                    <span>{{"common.active" | translate}}</span>
                  </span>


                  <span *ngIf="item['status'] === '1'"
                    class="inline-flex items-center px-4 py-2 rounded-full text-sm font-medium bg-gray-100 text-gray-800">
                    <span>

                      {{"common.under_review" | translate}}

                    </span>
                  </span>
                  <a (click)="showAppointmentStatusModal(item['id'] , item['status'])" class="cursor-pointer" *ngIf="item['status'] === '1'">

                    <svg class="svg-icon svg-icon-3 " width="24" height="24" viewBox="0 0 24 24" fill="none"
                      xmlns="http://www.w3.org/2000/svg">
                      <path opacity="0.3"
                        d="M21.4 8.35303L19.241 10.511L13.485 4.755L15.643 2.59595C16.0248 2.21423 16.5426 1.99988 17.0825 1.99988C17.6224 1.99988 18.1402 2.21423 18.522 2.59595L21.4 5.474C21.7817 5.85581 21.9962 6.37355 21.9962 6.91345C21.9962 7.45335 21.7817 7.97122 21.4 8.35303ZM3.68699 21.932L9.88699 19.865L4.13099 14.109L2.06399 20.309C1.98815 20.5354 1.97703 20.7787 2.03189 21.0111C2.08674 21.2436 2.2054 21.4561 2.37449 21.6248C2.54359 21.7934 2.75641 21.9115 2.989 21.9658C3.22158 22.0201 3.4647 22.0084 3.69099 21.932H3.68699Z"
                        fill="#9da2a9" />
                      <path
                        d="M5.574 21.3L3.692 21.928C3.46591 22.0032 3.22334 22.0141 2.99144 21.9594C2.75954 21.9046 2.54744 21.7864 2.3789 21.6179C2.21036 21.4495 2.09202 21.2375 2.03711 21.0056C1.9822 20.7737 1.99289 20.5312 2.06799 20.3051L2.696 18.422L5.574 21.3ZM4.13499 14.105L9.891 19.861L19.245 10.507L13.489 4.75098L4.13499 14.105Z"
                        fill="#9da2a9" />
                    </svg>

                  </a>
                </span>
              </td>

              <td class="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-light text-gray-900 sm:pl-6 text-right">
                <span class="d-flex justify-content-start flex-shrink-0 ">

                  <a nz-dropdown nzTrigger="click" [nzDropdownMenu]="menu" class="
                btn btn-icon btn-bg-light btn-active-color-primary btn-sm mx-2
              " target="_blank">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                      stroke="currentColor" class="w-6 h-6">
                      <path stroke-linecap="round" stroke-linejoin="round"
                        d="M13.19 8.688a4.5 4.5 0 011.242 7.244l-4.5 4.5a4.5 4.5 0 01-6.364-6.364l1.757-1.757m13.35-.622l1.757-1.757a4.5 4.5 0 00-6.364-6.364l-4.5 4.5a4.5 4.5 0 001.242 7.244" />
                    </svg>

                  </a>


                  <nz-dropdown-menu #menu="nzDropdownMenu">
                    <ul nz-menu>
                      <li nz-menu-item >
                        <a [href]="item['confirmation_message']">
                          {{'common.confirmation_message' | translate}}
                        </a>
              
                      
                      </li>
<!--                      <li nz-menu-item >-->
<!--                        <a [href]="item['confirmation_message']">-->
<!--                          {{'common.payment_message' | translate}}-->
<!--                        </a>-->
<!--              -->
<!--                      -->
<!--                      </li>-->
<!--                      <li nz-menu-item (click)="Language('ar')"> <span class="arabic-label">Payment</span> </li>-->
                    </ul>
                  </nz-dropdown-menu>


                  <a class="cursor-pointer
                  btn btn-icon btn-bg-light btn-active-color-primary btn-sm
                " nzPopconfirmTitle="{{'common.confirm_delete' | translate}}" nz-popconfirm nzOkText="{{'common.confirm_delete' | translate}}"
                    nzCancelText="{{'common.cancel' | translate}}" (nzOnConfirm)="deleteAppointments(item['id'])" (nzOnCancel)="cancel()">


                    <svg class="svg-icon svg-icon-3" width="24" height="24" viewBox="0 0 24 24" fill="none"
                      xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M5 9C5 8.44772 5.44772 8 6 8H18C18.5523 8 19 8.44772 19 9V18C19 19.6569 17.6569 21 16 21H8C6.34315 21 5 19.6569 5 18V9Z"
                        fill="#e61782" />
                      <path opacity="0.5"
                        d="M5 5C5 4.44772 5.44772 4 6 4H18C18.5523 4 19 4.44772 19 5V5C19 5.55228 18.5523 6 18 6H6C5.44772 6 5 5.55228 5 5V5Z"
                        fill="#e61782" />
                      <path opacity="0.5" d="M9 4C9 3.44772 9.44772 3 10 3H14C14.5523 3 15 3.44772 15 4V4H9V4Z"
                        fill="currentColor" />
                    </svg>

                  </a>

                </span>
              </td>
            </tr>
          </ng-container>
        </tbody>
        <!-- end::Table body -->
      </table>




      <nz-pagination style="direction: ltr !important; " [nzResponsive]="true" [nzPageSizeOptions]="[5, 10, 25, 30]"
        class="mt-2 pagination" [nzPageIndex]="currentPage" (nzPageIndexChange)="pageChange($event)"
        [nzPageSize]="pageSize" (nzPageSizeChange)="pageSizeChange($event)" [nzTotal]="pagenation['totalItems']"
        nzShowSizeChanger></nz-pagination>
    </nz-spin>
    <!-- end::Table -->
    <!-- </nz-spin> -->
  </div>
  <!-- end::Table container -->
</div>

<nz-modal dir="rtl" [(nzVisible)]="isAppointmentStatusVisible" [nzTitle]="modalTitle" [nzContent]="modalContent"
  [nzFooter]="modalFooter" (nzOnCancel)="handleAppointmentStatusCancel()">
  <ng-template #modalTitle class="text-start" dir="rtl">
    <p class="text-start">{{"common.update_booking_sttaus" | translate}}</p>



  </ng-template>

  <ng-template #modalContent style="float: right;" class="text-start">
    <p class="text-start  font-weight-bold mb-0">{{"common.booking_status" | translate}}</p>
    <div class="row clearfix mt-3 text-start">
      <div class="col-12 ">
        <div class="form-group">
          <div class="custom-controls-stacked ">
            <nz-radio-group [(ngModel)]="appointmentStatus" (ngModelChange)="SetAppointmentStatus($event)"
              [ngModelOptions]="{standalone: true}">
       

              <span>{{"common.active" | translate}}</span>
              <label nz-radio nzValue="1" class="ml-1"></label>
              <br>
              <span>{{"common.under_review" | translate}} </span>
              <label nz-radio nzValue="2" class="ml-1"> </label>
              <br>

            </nz-radio-group>
          </div>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #modalFooter>
    <button nz-button nzType="default" (click)="handleAppointmentStatusCancel()">{{"common.close" | translate}} </button>
    <button nz-button nzType="primary" (click)="updateAppointmentStatus()">{{"common.update" | translate}}
    </button>

  </ng-template>
</nz-modal>


<nz-modal [(nzVisible)]="isPaymentStatusVisible" [nzTitle]="modalTitlePaymentStatus"
  [nzContent]="PaymentStatusmodalContent" [nzFooter]="modalTitlePaymentStatusmodalFooter"
  (nzOnCancel)="handlePaymentStatusCancel()">
  <ng-template #modalTitlePaymentStatus>
    <p class="text-start">{{"common.update_payment_status" | translate}} </p>
  </ng-template>

  <ng-template #PaymentStatusmodalContent style="float: right;" class="text-start">

    <p class="text-start font-weight-bold mb-0">{{"common.payment_status" | translate}}</p>
    <div class="row clearfix mt-1 text-start">
      <div class="col-12 ">
        <div class="form-group">

          <div class="custom-controls-stacked ">


            <nz-radio-group [(ngModel)]="paymentStatus" (ngModelChange)="SetPaymentStatus($event)"
              [ngModelOptions]="{standalone: true}">
              <span>{{"common.paid" | translate}}</span>
              <label nz-radio nzValue="1" class="ml-1"></label>
              <br>
              <span>{{"common.unpaid" | translate}}</span>
              <label nz-radio nzValue="2" class="ml-1"> </label>
              <br>
              <span *ngIf="paymentStatusMSG" style="color: red;" > {{paymentStatusMSG}} </span>
              
            </nz-radio-group>
          </div>
        </div>
      </div>
    </div>

    <div class="row clearfix mt-0 text-start">
      <div class="col-12 ">
        <div class="form-group">

          <div class="custom-controls-stacked ">
            <p class="text-start font-weight-bold mb-1">{{"common.code" | translate}}</p>
      <span style="padding: 6px 12px;border: 1px dashed #00b7ff;border-radius: 8px;">{{code}}</span> 
          </div>
        </div>
      </div>
    </div>
    <div class="row clearfix mt-0 text-start">
      <div class="col-12 ">
        <div class="form-group">

          <div class="custom-controls-stacked ">
            <p class="text-start font-weight-bold mb-0">{{"common.invoice" | translate}}</p>
            <input nz-input placeholder="" [(ngModel)]="invoice" style="text-align: end;"  (input)="textChange()"/>
            <br>
            <span *ngIf="invoiceMSG" style="color: red;" > {{invoiceMSG}} </span>
          </div>
        </div>
      </div>
    </div>


  

  </ng-template>

  <ng-template #modalTitlePaymentStatusmodalFooter>
    <button nz-button nzType="default" (click)="handlePaymentStatusCancel()" >{{"common.close" | translate}} </button>
    <button nz-button nzType="primary" (click)="updatePaymentStatus()">
      {{"common.update" | translate}}
    </button>

  </ng-template>
</nz-modal>
